var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-user-article-card-list-container"},_vm._l((_vm.articles),function(article){return _c('article-card',{key:article.article_id,attrs:{"article":article,"link-to":_vm.linkTo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }